<template>
  <b-button
    size="md"
    variant="link"
    :style="{ backgroundColor: '#08A762', color: '#151515' }"
    class="ml-3"
    @click="performAction"
  >
    <i class="fa fa-file" />
    Create labels
  </b-button>
</template>

<script lang="ts">
import { BButton } from 'bootstrap-vue-next'
import { defineComponent } from 'vue'
import { LABELS_CREATING_LOADER } from '@/const/LoadersNames'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useUiStore } from '@/store/ui'

export default defineComponent({
  name: 'CreateLabels',
  components: { BButton },
  setup() {
    const uiStore = useUiStore()
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const performAction = () => {
      uiStore.loaderShow({
        name: LABELS_CREATING_LOADER,
        data: { progress: 0 },
      })

      assignmentSummaryStore.createLabels()
    }

    return {
      performAction,
    }
  },
})
</script>
